import React from "react";
import styled from "styled-components";
import { Button } from "../Common/Button";

export const MobileView = () => {
  return (
    <StyledMobile>
      <div className="mobile--header">
        <h1>
          This Free Email Signature Generator is best experienced on desktop
          devices. Try it out on a larger screen{" "}
          <span role="img" aria-label="smiling emoji">
            😅
          </span>
        </h1>
        <a
          value="mailto:?subject=Design Buffs' Free Email Generator&amp;body=www.designbuffs.com"
          rel="noopener noreferrer"
          href="mailto:?subject=Design Buffs' Free Email Generator&amp;body=www.designbuffs.com"
          target="_blank"
        >
          <Button>Email me the Link</Button>
        </a>
      </div>

      <div className="mobile--footer">
        <small>Created by:</small>
        <a
          href="https://designbuffs.com?ref=email-signature-tool"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="../../images/designbuffs_dark.png"
            alt="Design Buffs logo"
          />
        </a>
      </div>
    </StyledMobile>
  );
};

const StyledMobile = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  width: 100vw;
  height: 100vh;
  background-color: #311b92;
  .mobile--header {
    margin: 0 auto;
    font-size: 1.25rem;
    text-align: center;
    padding: 3rem;
    line-height: 2.25rem;
  }
  .mobile--footer {
    display: grid;
    justify-content: center;
    text-align: center;
    small {
      margin-bottom: 1rem;
    }
    img {
      transition: transform 0.2s ease-in-out;
    }
    img:hover {
      transform: rotate(-7deg);
    }
  }
  @media only screen and (min-width: 1000px) {
    display: none;
  }
  a {
    text-decoration: none;
  }
`;
